export default {
  googleAuthorizeTerms: "Esta aplicación dejará de ser compatible pasado el 10 de marzo de 2023. Instale nuestra nueva versión de {googleAppName}."
};

// @key: @#@"googleAuthorizeTerms"@#@ @source: @#@"This app will not be supported after Mar 10th, 2023. Please install our new version of {googleAppName}."@#@
